import type { SVGProps } from 'react'

export function CaretDown(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 12 12" fill="none" {...props}>
      <path d="M2 4l4 4 4-4H2z" fill="currentColor" />
    </svg>
  )
}
